import {Component, EventEmitter, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatSelectChange} from "@angular/material/select";

@Component({
    selector: 'adv-search-upcoming-ceu',
    templateUrl: './upcoming-ceu-advance-search.dialog.html',
})
export class UpcomingCeuAdvanceSearchDialog implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    optionDateRange: any[] = [
        {parameterLabel: 'All', parameterValue: '0'},
        {parameterLabel: 'This Week', parameterValue: '1'},
        {parameterLabel: 'Next Month', parameterValue: '2'},
    ];

    constructor(
        public dialogRef: MatDialogRef<UpcomingCeuAdvanceSearchDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder
    ) {
       this.form = this.formBuilder.group({
           provider: [[], []],
           ceType: [[], []],
           attendanceType: [null, []],
           dateRange: ['0', []]
        });
    }

    ngOnInit() {
        const filters = this.data.pageQuery.filters;
        if(filters && filters.dateRange) {
            this.form.controls.dateRange.setValue(filters.dateRange[0]);
        }
        if(filters && filters.provider) {
            this.form.controls.provider.setValue(filters.provider);
        }
        if(filters && filters.ceType) {
            this.form.controls.ceType.patchValue(filters.ceType);
            console.log(filters.ceType)
        }
        if(filters && filters.attendanceType) {
            this.form.controls.attendanceType.setValue(filters.attendanceType[0]);
        }
    }

    removeOption(option: any) {
        const selected = this.form.controls.provider.value.filter((o: string) => o !== option);
        this.form.controls.provider.setValue(selected);
    }

    removeOptionCEType(option: any) {
        const selected = this.form.controls.ceType.value.filter((o: string) => o !== option);
        this.form.controls.ceType.setValue(selected);
    }

    onCETypeChange($event: MatSelectChange) {
        this.form.controls.ceType.setValue($event.value);
    }

    onAttendanceTypeChange($event: MatSelectChange) {
        this.form.controls.attendanceType.setValue($event.value);
    }

    onProviderChange($event: MatSelectChange) {
        this.form.controls.provider.setValue($event.value);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    resetForm() {
        this.form.controls.provider.setValue([]);
        this.form.controls.ceType.setValue([]);
        this.form.controls.attendanceType.setValue(null);
        this.form.controls.dateRange.setValue('0');
    }

    applyFilter() {
        const payload = {
            provider: this.form.controls.provider.value,
            ceType: this.form.controls.ceType.value,
            attendanceType: [this.form.controls.attendanceType.value],
            dateRange: [this.form.controls.dateRange.value]
        }

        if(payload.ceType.length == 0) {
            payload.ceType = undefined;
        }

        if(payload.attendanceType[0] == null) {
            payload.attendanceType = undefined;
        }

        if(payload.provider.length == 0) {
            payload.provider = undefined;
        }

        this.result.emit(payload);
        this.closeDialog();
    }
}